import React from "react";
import { CheckCircle2 } from "lucide-react";
import { cn } from "../../../../lib/utils";

const BANNER_CONFIG = {
  active: "bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700",
  overdue: "bg-orange-50 dark:bg-orange-900/20 border-orange-200 dark:border-orange-800",
  inactive: "bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800",
};

export const SubscriptionBanner = ({ subscriptionStatus, planName }) => {
  const bannerClass = cn(
    "border rounded-xl p-6 shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-4",
    BANNER_CONFIG[subscriptionStatus] || BANNER_CONFIG.active
  );

  const displayPlanName = planName ? `${planName} plan` : "plan";

  return (
    <div className={bannerClass}>
      <div className="flex items-center gap-4">
        <div className="h-12 w-12 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center text-green-600 dark:text-green-400 flex-shrink-0">
          <CheckCircle2 />
        </div>
        <div>
          <h3 className="font-semibold text-gray-900 dark:text-white text-base">Active Subscription</h3>
          <p className="text-gray-600 dark:text-gray-400 text-sm">Your {displayPlanName} is active.</p>
        </div>
      </div>
    </div>
  );
};
